import { useEffect, useRef, useState } from 'react'
import { CSSTransition } from 'react-transition-group'

import Image from '../ui/Image/Image'
import { getImageUrl } from '../../utils'

import expand from '../../assets/images/faqExpand.svg'
import collapse from '../../assets/images/faqCollapse.svg'
import styles from './Accordion.module.scss'
import './Accordion.scss'

export const AccordionItem = ({
  image,
  question,
  answer,
  isOpen,
  onClick,
  children,
  titleClass,
  expandIcon,
  collapseIcon,
}) => {
  const contentRef = useRef(null)
  return (
    <div className={styles.accordionItem}>
      <div className={styles.accordionQuestion} onClick={onClick}>
        <div className={styles.titleContainer}>
          {image && (
            <Image
              className={styles.icon}
              src={getImageUrl(image)}
              alt={image?.alternativeText}
            />
          )}
          <span className={titleClass}>{question}</span>
        </div>
        {expandIcon && collapseIcon ? (
          <Image src={isOpen ? collapseIcon : expandIcon} alt="Collapse" />
        ) : (
          <Image src={isOpen ? collapse : expand} alt="Collapse" />
        )}
      </div>
      <CSSTransition
        in={isOpen}
        timeout={200}
        classNames={'accordion-content'}
        unmountOnExit
        nodeRef={contentRef}
      >
        <div className={styles['accordion-answer']} ref={contentRef}>
          {answer ? answer : null}
          {children}
        </div>
      </CSSTransition>
    </div>
  )
}

const Accordion = ({ data }) => {
  const [activeIndex, setActiveIndex] = useState(null)

  useEffect(() => {
    setActiveIndex(null)
  }, [data])

  const handleClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index)
  }

  return (
    <div className={styles.accordion}>
      {data.map((item, index) => (
        <AccordionItem
          key={'accordionItem' + item?.id}
          question={item.question}
          answer={item.answer}
          isOpen={activeIndex === index}
          onClick={() => handleClick(index)}
        />
      ))}
    </div>
  )
}

export default Accordion
